import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const PieceRemediationWizardRoute: RouteType = {
  name: "PieceRemediationWizard",
  path: "/workflows/piece-remediation",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Piece Remediation & Finishing Log",
      component: () => import("./PieceRemediationWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./PieceRemediationWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const panelStore = rootStore.panelStore as ServiceStore;
      const qcStore = rootStore.qcStore as ServiceStore;
      const fieldActivityIssuesStore = rootStore.fieldActivityIssuesStore as ServiceStore;
      const yardInventoryItemsStore = rootStore.yardInventoryItemsStore as ServiceStore;
      const holdStore = rootStore.holdStore as ServiceStore;

      await Promise.all([
        panelStore?.find(),
        qcStore?.find(),
        fieldActivityIssuesStore?.find(),
        yardInventoryItemsStore?.find(),
        holdStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for piece remediation:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).pieceRemediationWizardStore;
    store?.reset();
  },
};

export default PieceRemediationWizardRoute;